var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"mb-4"},[_c('p',{staticClass:"text-h2"},[_vm._v("Bienvenido a")]),_c('logo-sem-color',{staticClass:"mx-auto",staticStyle:{"max-width":"250px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }